export const CUSTOM_EVENTS = {
    COLLECTION_ACCOUNT_TRANSACTION: 'collectionAccountTransaction',
    ITEM_STOCK_SYNC_STARTED: 'itemStockSyncStarted',
    ITEM_STOCK_SYNC_SUCCESS: 'itemStockSyncSuccess',
    ITEM_STOCK_SYNC_FAILED: 'itemStockSyncFailed',
} as const;

export type CustomEventType =
    (typeof CUSTOM_EVENTS)[keyof typeof CUSTOM_EVENTS];
